import { render } from "./HeadingsBadges.vue?vue&type=template&id=95a7edfe&ts=true"
import script from "./HeadingsBadges.vue?vue&type=script&lang=ts"
export * from "./HeadingsBadges.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__